<template>
  <div class="sidebar-shell" :class="{ 'sidebar-shell--collapsed': !sidebar.opened }">
    <div
      class="sidebar-shell__intro"
      :class="{ 'sidebar-shell__intro--collapsed': !sidebar.opened }"
    >
      <div class="sidebar-shell__intro-content">
        <span class="sidebar-shell__label">{{ workspaceModeLabel }}</span>
        <strong class="sidebar-shell__title">{{ workspaceTitle }}</strong>
        <p class="sidebar-shell__description">{{ workspaceDescription }}</p>
      </div>
    </div>

    <div class="sidebar-shell__menu-wrap">
      <el-menu
        ref="kzMenu"
        class="sidebar-shell__menu"
        mode="vertical"
        :show-timeout="200"
        :default-active="defaultActive"
        :default-openeds="defaultOpen"
        :collapse="!sidebar.opened"
        :collapse-transition="false"
        background-color="transparent"
        text-color="#aebed7"
        active-text-color="#fff"
      >
        <sidebar-item :routes="routes" :enterpriseID="enterpriseID"></sidebar-item>
      </el-menu>
    </div>

    <div
      class="sidebar-shell__footer"
      :class="{ 'sidebar-shell__footer--collapsed': !sidebar.opened }"
    >
      <div class="sidebar-shell__footer-content">
        <span class="sidebar-shell__footer-dot"></span>
        <span>{{ footerMessage }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { handleRoute } from '@/utils/common';
import { mapGetters } from 'vuex';

export default {
  name: 'Sidebar',
  props: ['enterpriseID'],
  data() {
    return {
      defaultActive: '',
      defaultOpen: ['deliverManage', 'Stores']
    };
  },

  created() {
    const enterpriseMarket =
      this.enterpriseInfo &&
      this.enterpriseInfo.marketID != '' &&
      this.enterpriseInfo.openMarket;
    if (enterpriseMarket) {
      this.defaultOpen = ['deliverManage', 'Stores', 'myApp'];
    } else {
      this.defaultOpen = ['enterpriseManage', 'myApp'];
    }

    const pathname = window.location.pathname;
    if (this.$route && this.$route.meta && this.$route.meta.currentActive) {
      this.defaultActive = this.$route.meta.currentActive;
    } else {
      this.defaultActive = pathname;
    }
  },
  watch: {
    $route(route) {
      // 通过路由地址 :default-active="$router.currentRoute.path"
      // 默认只有二级

      if (route.meta && route.meta.currentActive) {
        this.defaultActive = route.meta.currentActive;
        return null;
      }
      const paths = route.path.split('/');

      const path =
        paths && paths.length
          ? paths.slice(0, 6).join('/') || paths.slice(0, 5).join('/')
          : route.path;
      // element nav的数据是缓存的
      // 重新传入list并不会更新路由地址作为的key
      this.defaultActive = path;
    }
  },
  computed: {
    ...mapGetters(['sidebar']),

    routes() {
      const routes = this.$router.options.routes;
      const enterpriseMarket =
        this.enterpriseInfo &&
        this.enterpriseInfo.marketID != '' &&
        this.enterpriseInfo.openMarket;
      return handleRoute(enterpriseMarket, routes);
    },

    enterpriseInfo() {
      return this.$store.state.enterprise.enterpriseInfo || {};
    },

    userInfo() {
      return this.$store.state.user.userInfo;
    },

    workspaceTitle() {
      if (this.enterpriseInfo && this.enterpriseInfo.name) {
        return this.enterpriseInfo.name;
      }
      return '应用市场后台';
    },

    workspaceModeLabel() {
      return this.enterpriseInfo && this.enterpriseInfo.openMarket
        ? 'MARKET OPS'
        : 'ENTERPRISE SPACE';
    },

    workspaceDescription() {
      return this.enterpriseInfo && this.enterpriseInfo.openMarket
        ? '聚合商店、应用、订单与交付流程的统一管理入口'
        : '聚合企业应用与团队协作入口的统一工作台';
    },

    footerMessage() {
      if (this.userInfo && this.userInfo.realName) {
        return `欢迎回来，${this.userInfo.realName}`;
      }
      return '导航会根据当前权限自动收敛';
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue